import settings from '../util/settings';

const getApiType = () => settings.apiType;

const api = require(`./api.${getApiType()}`);
export default api;